import { IAdminMiningTableProps } from "./AdminMiningTable.props";
import styles from "./AdminMiningTable.module.scss";
import cn from "classnames";
import { moscowTime } from "@utils/moscowTime";
import Loader from "@components/global/Loader/Loader";
import { memo } from "react";
import { useAdminMiningTableControl } from "./useAdminMiningTableControl";
import { useIntl } from "react-intl";
import { localeMiningDays } from "@utils/localeMiningDays";
import { useLocale } from "@utils/hooks/useLocale";

function AdminMiningTable({
  table,
  className,
  isUser,
  percent,
  miner_plan,
  minerID,
}: IAdminMiningTableProps) {
  const { locale } = useLocale();
  const { formatMessage } = useIntl();
  const control = useAdminMiningTableControl(
    {
      percent,
      adminMining: table,
      miner_plan,
    },
    minerID
  );
  return (
    <div className={cn(styles.wrapper, className)}>
      {control.loading && <Loader size={30} />}
      {isUser && <h5>{formatMessage({ id: "machines.admin_mining" })}</h5>}
      <div className={styles.proof_wrapper}>
        {control.table && control.table.length > 0 ? (
          control.table.map((item, i) => (
            <div className={styles.proof} key={i}>
              <h5>#{localeMiningDays(i, locale)}</h5>
              {item.range.map((p, j) => (
                <p key={j}>
                  {moscowTime(p[0] * 1000, { format: "HH:mm" })} -{" "}
                  {moscowTime(p[1] * 1000, { format: "HH:mm" })}
                </p>
              ))}
            </div>
          ))
        ) : (
          <p className={styles.various}>
            {formatMessage({ id: "machines.admin_mining.various" })}
          </p>
        )}
      </div>
    </div>
  );
}

export default memo(AdminMiningTable);
